import * as React from 'react'

import { Container, ContentContainer, LoaderBar } from './Loader.styles'

interface IProps {
  collapse?: boolean
}

export default function Loader(props: IProps) {
  const { collapse } = props

  return (
    <Container collapse={collapse}>
      <ContentContainer>
        <LoaderBar />
        <LoaderBar />
        <LoaderBar />
        <LoaderBar />
      </ContentContainer>
    </Container>
  )
}
